import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_prfgqs5geu: FaireCollectionEntity = {
  token: "pbc_prfgqs5geu",
  type: "collection",
  name: "COASTAL BLISS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2bbd06ee83a23a8e92230d8e6801882f56e45557852854cc45e4edd34d30b1bc.jpeg",
  itemCount: 9,
  description:
    "Beach resort vibes shine in these women’s sandals, and slip-ons. With soft pastels, and woven details, they’re perfect for seaside strolls or sunny getaways. \nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.478Z",
    importedBy: "entity-db-import-collections",
  },
};
